import { render, staticRenderFns } from "./SuccessDialog.vue?vue&type=template&id=2b2b1bd3&scoped=true"
import script from "./SuccessDialog.vue?vue&type=script&lang=js"
export * from "./SuccessDialog.vue?vue&type=script&lang=js"
import style0 from "./SuccessDialog.vue?vue&type=style&index=0&id=2b2b1bd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2b1bd3",
  null
  
)

export default component.exports